import { IOrderAddressInput } from 'remote/queries/order';
import { StoreProxy } from 'state/store';

export const buildStoreAddress = (store: StoreProxy): IOrderAddressInput => {
  const { address1, address2, city, country, postalCode, stateProvince } =
    store.physicalAddress ?? {};
  const storeEmail = store.email && store.email.length > 0 ? store.email[0] : '';

  return {
    addressLine1: address1 || '',
    addressLine2: address2,
    city: city || '',
    country: country || '',
    zip: postalCode || '',
    state: stateProvince || '',
    phoneNumber: store.phoneNumber || '',
    email: storeEmail,
  };
};
